import React, { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const DEFAULT_INTERVAL_MS = 400;

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'inline-flex',
    alignItems: 'baseline',
  },
  dots: {
    display: 'inline-block',
    width: '1.5em', // prevents layout shift as dots change
    textAlign: 'left',
    marginLeft: theme.spacing(0.25),
  },
}));

interface EllipsisLoaderProps {
  text: string;
  intervalMs?: number;
  fontSize?: number;
  style?: React.CSSProperties;
}

export default function EllipsisLoader(props: EllipsisLoaderProps) {
  const classes = useStyles();
  const { text, intervalMs, fontSize, style } = props;

  const [count, setCount] = useState(text ? 0 : 1);

  useEffect(() => {
    const id = window.setInterval(() => {
      setCount((c) => (c + 1) % 4); // 0..3
    }, intervalMs || DEFAULT_INTERVAL_MS);

    return () => window.clearInterval(id);
  }, []);

  const suffix = '.'.repeat(count); // "", ".", "..", "..."

  return (
    <span className={classes.wrapper} style={style}>
      <Typography component="span" variant="h6" style={{ textTransform: 'none', fontSize }}>
        {text}
      </Typography>
      <Typography component="span" variant="h6" className={classes.dots} style={{ fontSize }}>
        {suffix}
      </Typography>
    </span>
  );
}
